class ChooseJobBoardCredentialTypeModalController {
    constructor() {
        // this.addJobBoardByPasswordFlag = this.resolve.addJobBoardByPasswordFlag;
    }
    $onInit() {
        this.addJobBoardByPasswordFlag = this.resolve.addJobBoardByPasswordFlag;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    }
    onTypeSelected() {
        this.callbackObject = { callbackType: 'typeChange', entity: { addJobBoardByPasswordFlag: this.addJobBoardByPasswordFlag } };
        this.closeModal();
    }
    closeModal() {
        this.modalInstance.close(this.callbackObject);
    }
    dismissModal() {
        this.modalInstance.dismiss('cancel');
    }
}
// import * as TEMPLATE from './choose-job-board-credential-type-modal.html';
import * as TEMPLATE from 'raw-loader!./choose-job-board-credential-type-modal.html';
export const ChooseJobBoardCredentialTypeModalComponent = {
    selector: 'chooseJobBoardCredentialTypeModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: ChooseJobBoardCredentialTypeModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/company/chooseJobBoardCredentialTypeModal/choose-job-board-credential-type-modal.html'
    }
};
//# sourceMappingURL=choose-job-board-credential-type-modal.component.js.map